import { useMemo } from 'react';

import { useSessionInfo } from '@store';
import { BaseSessionInfoLoanType } from '@types';

/**
 * @param values An object that maps credit types to specific values.
 * @param fallback A default value that will be used if the credit type from the session info does not have a corresponding value in the values object.
 * @returns The value corresponding to the current credit type, or the fallback if the credit type is not defined in the values object.
 */
export const useGetValueByCreditType = <T extends string | number | object | boolean | Array<T>>(
	values: Partial<Record<BaseSessionInfoLoanType, T>>,
	fallback: T
): T => {
	const sessionInfo = useSessionInfo();
	const creditType = (sessionInfo?.journeyData?.loanType || BaseSessionInfoLoanType.CL) as BaseSessionInfoLoanType;

	return useMemo(() => values[creditType] ?? fallback, [creditType, values, fallback]);
};
